import { useLayoutStore } from "@/Stores/layout"
import { useLocaleStore } from "@/Stores/locale"
import { router, usePage } from "@inertiajs/vue3"
// import { loadLanguageAsync } from "laravel-vue-i18n"
import { watchEffect } from "vue"
import { useEchoGrpPersonal } from '@/Stores/echo-grp-personal.js'
import { useEchoGrpGeneral } from '@/Stores/echo-grp-general.js'
import { useLiveUsers } from '@/Stores/active-users'

export const initialiseApp = () => {
    const layout = useLayoutStore()
    const locale = useLocaleStore()

    // Declaring here cuz some component failing retrieve on first load (EmployeePosition.vue)
    layout.currentParams = route().v().params
    router.on('navigate', (event) => {
        // console.log('layout env', layout.app.environment)
        layout.currentParams = route().v().params  // current params
        layout.currentRoute = route().current() || ''  // current route
    })

    const storageLayout = JSON.parse(localStorage.getItem('layout') ?? '{}')  // Get layout from localStorage
    layout.organisationsState = storageLayout  // { 'awa' : { currentShop: 'bali', currentWarehouse: 'ed' }, ... }

    const echoPersonal = useEchoGrpPersonal()
    const echoGeneral = useEchoGrpGeneral()

    useLiveUsers().subscribe()  // Websockets: active users
    echoGeneral.subscribe(usePage().props.layout?.group?.id)  // Websockets: notification



    // if (usePage().props.localeData) {
    //     loadLanguageAsync(usePage().props.localeData.language.code)
    // }

    watchEffect(() => {

        // Set App theme
        // if (usePage().props.layout?.app_theme) {
        //     layout.app.theme = usePage().props.layout?.app_theme
        // }

        // Set App Environment
        // if (usePage().props?.environment) {
        //     layout.app.environment = usePage().props?.environment
        // }

        layout.auth = usePage().props.auth


        layout.app.name = "Aiku"
    })
}
